import React, { useState, useEffect } from "react";
import Textfield from "@atlaskit/textfield";
import InlineEdit from "@atlaskit/inline-edit";
import { setEditorSaved } from "../../../../../../../redux/actions/integrationActions";
import { useDispatch } from "react-redux";

const ScriptedNameTextField = ({ scriptedVariable }) => {
  const dispatch = useDispatch();
  const [editValue, setEditValue] = useState(scriptedVariable.name ? scriptedVariable.name : "");

  const onSetVarName = (name) => {
    setEditValue(name);
    scriptedVariable.name = name;
    dispatch(setEditorSaved(false));
  };

  return (
    <InlineEdit
      defaultValue={editValue}
      editView={({ errorMessage, ...fieldProps }) => <Textfield {...fieldProps} autoFocus />}
      readView={() => <>{editValue || "Click to enter a value"}</>}
      onConfirm={(value) => onSetVarName(value)}
    />
  );
};

export default ScriptedNameTextField;
